<!-- `inline`: os campos entram direto na po-row de quem chama, sem embrulho próprio.
     É o que o painel de custos precisa — lá período, área, usuário e tipo de review são
     um recorte só e dividem a mesma linha do grid. Ver `inline` no componente. -->
<ng-container *ngIf="inline; else ownRow">
  <ng-container *ngTemplateOutlet="fields"></ng-container>
</ng-container>

<ng-template #ownRow>
  <div class="po-row">
    <ng-container *ngTemplateOutlet="fields"></ng-container>
  </div>
</ng-template>

<ng-template #fields>
  <po-select
    name="periodPreset"
    [class]="presetClass"
    p-label="Período"
    [p-options]="presetOptions"
    [ngModel]="preset"
    (ngModelChange)="onPresetChange($event)">
  </po-select>

  <po-datepicker-range
    *ngIf="isCustom"
    name="periodRange"
    [class]="rangeClass"
    p-label="Intervalo"
    [(ngModel)]="range"
    (p-change)="onRangeChange()">
  </po-datepicker-range>
</ng-template>
